<div class="sfd-overlay" (click)="onClose()">
  <div class="sfd-card" role="dialog" aria-modal="true" aria-labelledby="sfd-title"
    (click)="$event.stopPropagation()">

    @if (sent()) {
      <!-- ── Sent state ── -->
      <div class="sfd-sent">
        <span class="sfd-sent__check">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </span>
        <h2 class="sfd-sent__title">Thanks for your feedback</h2>
        <p class="sfd-sent__sub">
          Your feedback has been shared with the Agent Hub team. We review every submission.
        </p>
        <button type="button" class="sfd-btn sfd-btn--primary" (click)="onClose()">Done</button>
      </div>
    } @else {
      <!-- ── Form state ── -->
      <div class="sfd-head">
        <svg class="sfd-head__icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8z" />
        </svg>
        <h2 class="sfd-head__title" id="sfd-title">Send Feedback</h2>
        <button type="button" class="sfd-icon-btn" (click)="onClose()" [disabled]="submitting()" aria-label="Close">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
            <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>

      <div class="sfd-body">
        <div class="sfd-field">
          <span class="sfd-label" id="sfd-cat-label">What kind of feedback is this?</span>
          <div class="sfd-chips" role="group" aria-labelledby="sfd-cat-label">
            @for (c of categories; track c.id) {
              <button type="button" class="sfd-chip" [class.sfd-chip--active]="category() === c.id"
                (click)="selectCategory(c.id)">
                <span class="sfd-chip__icon">
                  @switch (c.id) {
                    @case ('bug') {
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <rect x="8" y="6" width="8" height="14" rx="4" /><path d="M19 7l-3 2M5 7l3 2M19 13h-3M5 13h3M19 19l-3-2M5 19l3-2M12 2v4" />
                      </svg>
                    }
                    @case ('idea') {
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M9 18h6M10 22h4M12 2a7 7 0 0 0-4 12.7c.6.5 1 1.3 1 2.1h6c0-.8.4-1.6 1-2.1A7 7 0 0 0 12 2Z" />
                      </svg>
                    }
                    @case ('agent') {
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 2l2.4 5.9 6.1.5-4.6 4 1.4 6L12 15.3 6.7 18.4l1.4-6-4.6-4 6.1-.5L12 2Z" />
                      </svg>
                    }
                    @default {
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <circle cx="12" cy="12" r="9" /><path d="M9.1 9a3 3 0 0 1 5.8 1c0 2-3 2.5-3 4" /><line x1="12" y1="17" x2="12.01" y2="17" />
                      </svg>
                    }
                  }
                </span>
                {{ c.label }}
              </button>
            }
          </div>
        </div>

        <div class="sfd-field">
          <label class="sfd-label" for="sfd-message">Tell us more</label>
          <textarea id="sfd-message" class="sfd-textarea" rows="5" [value]="message()" (input)="onMessageInput($event)"
            placeholder="Describe what's working, what's not, or what you'd like to see…"></textarea>
        </div>

        <!-- Chat context is opt-in and always spelled out: what's attached (with
             a reviewable preview), or why nothing can be attached right now. -->
        <div class="sfd-field">
          <span class="sfd-label">Chat context</span>
          @if (hasConversation()) {
            <label class="sfd-check">
              <button type="button" class="sfd-check__box" [class.sfd-check__box--on]="includeConversation()"
                (click)="toggleAttach()" [attr.aria-pressed]="includeConversation()" aria-label="Share this chat with my feedback">
                @if (includeConversation()) {
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3">
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                }
              </button>
              <span (click)="toggleAttach()">
                Share this chat{{ agentName ? ' with ' + agentName : '' }}
                ({{ conversation.length }} {{ conversation.length === 1 ? 'message' : 'messages' }})
              </span>
            </label>
            @if (includeConversation()) {
              <button type="button" class="sfd-context-toggle" (click)="togglePreview()"
                [attr.aria-expanded]="previewOpen()">
                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"
                  [class.sfd-context-toggle__chev--open]="previewOpen()" class="sfd-context-toggle__chev">
                  <polyline points="9 6 15 12 9 18" />
                </svg>
                {{ previewOpen() ? 'Hide' : 'Review' }} what will be shared
              </button>
              @if (previewOpen()) {
                <div class="sfd-context-preview" role="region" aria-label="Conversation that will be shared">
                  @for (turn of conversation; track $index) {
                    <div class="sfd-context-preview__turn">
                      <span class="sfd-context-preview__role"
                        [class.sfd-context-preview__role--agent]="turn.role === 'assistant'">
                        {{ turn.role === 'assistant' ? 'Agent' : 'You' }}
                      </span>
                      <span class="sfd-context-preview__text">{{ turn.content }}</span>
                    </div>
                  }
                </div>
              }
            } @else {
              <p class="sfd-context-hint">Off — only the message above is sent, nothing from this chat.</p>
            }
          } @else {
            <p class="sfd-context-hint">
              No chat is attached. To include a conversation with your feedback,
              open that chat first and choose Send Feedback from there.
            </p>
          }
        </div>

        <div class="sfd-info">
          <svg class="sfd-info__icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10" /><line x1="12" y1="16" x2="12" y2="12" /><line x1="12" y1="8" x2="12.01" y2="8" />
          </svg>
          <span>Your feedback is saved to the Agent Hub feedback log and emailed to the support team, along with your name and account.
            Chat context is included only if you turn it on above.</span>
        </div>

        @if (error()) {
          <div class="sfd-error" role="alert">{{ error() }}</div>
        }
      </div>

      <div class="sfd-foot">
        <button type="button" class="sfd-btn sfd-btn--ghost" (click)="onClose()" [disabled]="submitting()">Cancel</button>
        <button type="button" class="sfd-btn sfd-btn--primary" (click)="submit()" [disabled]="!canSubmit()">
          {{ submitting() ? 'Sending…' : 'Submit Feedback' }}
        </button>
      </div>
    }
  </div>
</div>
